import { Raffle } from '../types/raffle';
import { GeneralTabErrors, GeneralTabFill } from '../types/tabsError';

export const checkTourLink = (link: string): string => {
  if (!link) {
    return '';
  }
  const match = /embed/;
  const watch = /watch/;
  if (match.test(link)) {
    return link;
  }
  const result = link.split('/');
  const newLink = result.reduce((acc, item, index) => {
    if (watch.test(item)) {
      const replace = item.split('=');
      item = `embed/${replace[replace.length - 1]}`;
    }
    acc += item;
    if (index === result.length - 1) {
      return acc;
    }
    acc += '/';
    index++;
    return acc;
  }, '');
  return newLink;
};

export const checkDiscount = (data: Raffle): boolean => {
  if (data.discountCategory === 'cash' && data.discountRates) {
    for (let i = 0; i < data.discountRates.length; i++) {
      if (
        data.discountRates[i].newPrice > 99 ||
        data.discountRates[i].percent < 0 ||
        data.discountRates[i].amountTickets < 0 ||
        data.discountRates[i].newPrice < 0
      ) {
        return false;
      }
    }
  }
  if (data.discountCategory === 'percent' && data.discountRates) {
    for (let i = 0; i < data.discountRates.length; i++) {
      if (
        data.discountRates[i].percent > 99 ||
        data.discountRates[i].percent < 0 ||
        data.discountRates[i].amountTickets < 0 ||
        data.discountRates[i].newPrice < 0
      ) {
        return false;
      }
    }
  }
  return true;
};

export const checkDiscountFill = (data: Raffle): boolean => {
  if (data.isDiscountRates && data.discountRates?.length === 0) {
    return true;
  }
  return false;
};

export const checkPreviousValue = (data: Raffle) => {
  if (data.property.discountRates) {
    for (let i = 1; i < data.property.discountRates.length; i++) {
      if (
        data.property.discountRates[i - 1].amountTickets >=
        data.property.discountRates[i].amountTickets
      ) {
        return false;
      }
    }
  }
  return true;
};

export const checkDateError = (data): boolean => {
  const startDate = new Date(data.startAt).getTime();
  const endDate = new Date(data.endsAt).getTime();
  if (startDate >= endDate) {
    return true;
  }
  return false;
};
export const checkCreditsDateError = (data): boolean => {
  const creditsStartDate = new Date(data.creditsStartDate).getTime();
  const creditsEndDate = new Date(data.creditsEndDate).getTime();
  if (creditsStartDate >= creditsEndDate) {
    return true;
  }
  return false;
};

export const checkIsDatesValid = (startDate, endDate): boolean => {
  const startDateV = new Date(startDate).getTime();
  const endDateV = new Date(startDate).getTime();
  if (startDateV >= endDateV) {
    return true;
  }
  return false;
};

export const checkGeneralError = (data: GeneralTabFill) => {
  let generalResultError = false;
  let generalResult: GeneralTabErrors = {
    imagesError: !data.imagesFill ? true : false,
    emailGalleryImageError: !data.emailGalleryImage ? true : false,
    // adressError: !data.adressFill ? true : false,
    adressError: false,
    endDateError: !data.endDateFill ? true : false,
    startDateError: !data.startDateFill ? true : false,
    titleError: !data.title ? true : false,
  };
  if (
    generalResult.adressError ||
    generalResult.imagesError ||
    generalResult.emailGalleryImageError ||
    generalResult.endDateError ||
    generalResult.startDateError ||
    generalResult.titleError
  ) {
    generalResultError = true;
    return { generalResult, generalResultError };
  }
  generalResult = {
    imagesError: data.imagesFill.length === 0 ? true : false,
    // adressError: data.adressFill.length === 0 ? true : false,
    adressError: false,
    endDateError: data.endDateFill.length === 0 ? true : false,
    startDateError: data.startDateFill.length === 0 ? true : false,
    titleError: data.title.length === 0 ? true : false,
  };
  if (
    generalResult.adressError ||
    generalResult.imagesError ||
    generalResult.endDateError ||
    generalResult.startDateError ||
    generalResult.titleError
  ) {
    generalResultError = true;
  }
  if (
    checkDateError({ startAt: data.startDateFill, endsAt: data.endDateFill })
  ) {
    generalResultError = true;
  }
  return { generalResult, generalResultError };
};
